'use strict';

var angular = require('angular');
var DeleteFlightTagModalDirective = function DeleteFlightTagModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/delete-flight-tag-modal.html'),
    link: function link($scope, element) {
      $scope.hideDialogAndRemoveFlightTags = function () {
        $scope.removeFlightTags();
        $scope.showDeleteModal = false;
      };
      $scope.cancelRemoveFlightTags = function () {
        $scope.$broadcast('grid:dataChanged');
        $scope.showDeleteModal = false;
      };
      $scope.$watch('showDeleteModal', function (newVal) {
        if (newVal) {
          angular.element('#delete-flight-tag-modal').modal('show');
        } else {
          element.parent('.modal:first').modal('hide');
        }
      });
    }
  };
};
DeleteFlightTagModalDirective.$inject = [];
module.exports = DeleteFlightTagModalDirective;